import { computed, defineComponent, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput"; // modules

import AppModule from "@/store/modules/app"; // helpers

import { convertCodeToIdLang } from "@/utils/helpers/lang";
import { zipCode } from "@/utils/validate";
import POSConfigModule from "@/store/modules/pos-config";
import CommonModule from "@/store/modules/common";
export default defineComponent({
  name: "CustomerCreateForm",
  components: {
    MazPhoneNumberInput: MazPhoneNumberInput
  },
  setup: function setup() {
    var _POSConfigModule$grou;

    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var form = ref(); // get the group's country code

    var groupBranding = (_POSConfigModule$grou = POSConfigModule.groupInfo) === null || _POSConfigModule$grou === void 0 ? void 0 : _POSConfigModule$grou.brandingList;
    var groupCountry;

    if (groupBranding && groupBranding[0] && groupBranding[0].country) {
      groupCountry = groupBranding[0].country.alpha2;
    } else {
      groupCountry = "CH";
    }

    var userCurrentCountry = computed(function () {
      return CommonModule.userCurrentCountry;
    });
    var GET_YES_NO_CONTENT = computed(function () {
      return [{
        value: 0,
        label: t("common.no")
      }, {
        value: 1,
        label: t("common.yes")
      }];
    });
    var ruleForm = reactive({
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      language: convertCodeToIdLang(AppModule.language),
      birthDate: "",
      allergies: "",
      address: "",
      zipCode: "",
      city: "",
      country: userCurrentCountry.value || groupCountry,
      phone: "",
      company: "",
      emailMarketingOrganiser: ""
    });
    var rules = reactive({
      firstName: [{
        required: true,
        message: t("field.first-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.first-name-min-max"),
        trigger: "change"
      }],
      lastName: [{
        required: true,
        message: t("field.last-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.last-name-min-max"),
        trigger: "change"
      }],
      email: [{
        required: true,
        message: t("field.email-required"),
        trigger: "blur"
      }, {
        type: "email",
        message: t("field.email-invalid"),
        trigger: ["blur", "change"]
      }],
      language: {
        required: true,
        message: t("field.language-empty"),
        trigger: "change"
      },
      company: {
        max: 50,
        message: t("field.company-max"),
        trigger: "change"
      },
      city: [{
        max: 50,
        message: t("field.city-max"),
        trigger: "change"
      }],
      zipCode: [{
        pattern: zipCode,
        message: t("field.zip-code-invalid"),
        trigger: "change"
      }]
    });
    return {
      form: form,
      ruleForm: ruleForm,
      rules: rules,
      GET_YES_NO_CONTENT: GET_YES_NO_CONTENT
    };
  }
});